import styled from "styled-components";

import Background from '../../../../assets/images/banners/banner_site3.webp';

export const BaseDiv = styled.div`
    position: relative;
    background-image: url(${Background});
    background-size: cover; /* Or use 'contain' based on your design needs */
    background-position: center;
    background-repeat: no-repeat;
    margin: 2% 0%;
    padding: 6% 0;
    max-width: '100%';
    justify-content: center;
    display: flex;
    max-width: 100%;

    will-change: transform;
    contain: layout;


    @media only screen and (max-width: 1000px) {
        background-image: url(${Background});
    }

    .SwiperName {
        @media only screen and (max-width: 800px) {
            max-width: 50%;
            width: 50%;
        }
    }

    .swiper-wrapper .wiper-slide {
        @media only screen and (max-width: 800px) {
            width: 200px;
        }
    }
`;

export const PrincipalDiv = styled.div`
    width: 100%;
    padding: 8%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .clientesTitle {
        position: absolute;
        top: 3%;
        text-align: center;

    }

    @media only screen and (max-width: 2000px) {
        padding: 6%;
    }
    @media only screen and (max-width: 1700px) {
        padding: 5%;
    }

    @media only screen and (max-width: 1400px) {
        padding: 4%;
    }
    @media only screen and (max-width: 1300px) {
        padding: 3%;
    }
    @media only screen and (max-width: 1100px) {
        padding:1%;
    }
    @media only screen and (max-width: 800px) {
        padding:5%;
    }
    @media only screen and (max-width: 700px) {
        padding: 10% 4%;
    }
    @media only screen and (max-width: 600px) {
        padding: 8% 3%;
    }
    /* @media only screen and (max-width: 1700px) {
        padding: 5%;
    }
    
    @media only screen and (max-width: 1100px) {
        padding: 2% 5%;
    }
    @media only screen and (max-width: 1000px) {
        padding: 3% 5%;
    } */
    /* @media only screen and (max-width: 1100px) {
        padding: 1% 3%;
    } */
    /* @media only screen and (max-width: 800px) {
        margin-top: -10%;
    }
    @media only screen and (max-width: 500px) {
        margin-top: 0%;
    } */
`;

export const CardBody = styled.div`
    background-color: white;
    height: 470px;
    @media only screen and (max-width: 1600px) {
        height: 460px
    }
    @media only screen and (max-width: 1400px) {
        height: 440px
    }
    @media only screen and (max-width: 1300px) {
        height: 380px
    }
    @media only screen and (max-width: 1200px) {
        height: 385px
    }
    @media only screen and (max-width: 900px) {
        height: 400px
    }
    @media only screen and (max-width: 600px) {
        height: 93%
    }
    /* @media only screen and (max-width: 450px) {
        height: 95%
    } */
    /* @media only screen and (max-width: 800px) {
        height: 500px
    } */
    color: var(--purple-lightdark);
`;

export const CardLogo = styled.div`
    height: 85px;
    padding-top: 2px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: 800px) {
        height: 60px;
        padding-top: 2px;
    }
    img {
        max-width: 100;
        max-height: 20;
    }
`;

export const CardContent = styled.div`
    p {
        font-size: 12px;
        padding: 5px 20px;
    }
`;

export const CardName = styled.div`
    font-weight: bold;
    font-size: 14px;
`;

